import React from "react";

export const DataComp = React.memo(
  ({
    src,
    alt,
    ee,
    h2Title,
    p_Desc,
    post_author,
    post_location,
    post_date,
    withZoom,
    loading,
    srcSet,
    name,
    
   imgHeight = "250px",
   imgClassName,
   imgClassName1
  }) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return (
      <div
        className={ee}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "15px",
          width:"100%",
          flex:"1",
        

          
        }}
      >
        <figure   className={withZoom ? "image-container" : ""}>
          <div >
            <img
            src={src}
            srcSet={srcSet}
            className={`${name ? "homeContent" : "homeImg"} ${imgClassName || ""} ${imgClassName1 || ""}`}

            alt={alt}
            width="500"
            height="500"
            loading={loading}
            
            
            // style={{width:"100%",height:"auto",objectFit:"fill"}}
          />
          </div>
          
        </figure>
        <div>
          <h2
            style={{ fontWeight: "600" }}
            className="h4 hoverHead"
          >
            {h2Title}
          </h2>
          {(post_author || post_location) && ( 
            <p style={{ fontSize: "12px" }}>
              {post_author && (
                <>
                 By <span className="fw-bold">{post_author}</span> |{" "}
                </>
              )}
           
              {post_location && <>{post_location}</>}
              {post_date &&
                "" + new Date(post_date).toLocaleDateString(undefined, options)}
            </p>
          )}
          <p
            className="just-text line-clamp mt-1"
            style={{ fontSize: "12px" }}
          >
            {p_Desc}
          </p>
        </div>
        
      </div>
    );
  }
);
